export default __webpack_public_path__ + "static/media/Logo-Sin-Fondo.a882abe0.png";